import React from 'react';
import './fundInfoCard.css'
const FundInfoCard = ({ fundInfo,index }) => {
    return (
        <div className="col-md-6" >
            <a target="_blank" className="text-decoration-none" href={fundInfo?.link[0]?.text}>
            <div className=" fund-card ">
                <div className="fund-media  ">
                    <img src={fundInfo?.icon?.url} alt="" className="img-fluid" />
                </div>
              
                    <p className="  primary-text primary-fnt p-0 m-0 ">{fundInfo?.title1[0]?.text} </p>
 
            </div>
            </a>
        </div>
    );
};

export default FundInfoCard;